module.exports = __webpack_public_path__ + "static/media/p6.254f8e9f.png";